import ShadowContainerVertical from '@atoms/ShadowContainerVertical/ShadowContainerVertical';
import ILanguageSelector from '@models/ILanguageSelector';
import useIsInIFrame from '@utils/hooks/useIsInIFrame';
import classNames from 'classnames';
import { motion } from 'framer-motion';

interface Props {
  readonly languageSelector?: ILanguageSelector;
  readonly languageActiveIndex: number;
}

const MobileLanguageSelector = ({
  languageSelector,
  languageActiveIndex,
}: Props) => {
  const { title = '' } = languageSelector || {};
  const isInIFrame = useIsInIFrame();

  return (
    <motion.div
      className="absolute top-0 right-0 bottom-0 left-0 overflow-y-auto"
      initial={{ x: '200%' }}
      animate={{ x: '100%' }}
      exit={{ x: '200%' }}
      transition={{
        delay: 0.15,
        duration: 1.1,
        ease: [0.74, 0, 0.19, 1.02],
      }}
      data-testid="Language-Selector-Mobile"
    >
      <ShadowContainerVertical shadowColour="from-white">
        <div className="container w-full list-none pb-7.5 text-black-100">
          {title && (
            <p
              className="h5 pb-7.5"
              data-testid="Language-Selector-Mobile-Title"
            >
              {title}
            </p>
          )}

          {!!languageSelector?.links?.length && (
            <ul className="flex flex-col items-start gap-y-7.5">
              {languageSelector.links.map(
                ({ url, target, longName, shortName, name, lang }, index) => (
                  <li
                    className="body-two shrink-0 cursor-pointer"
                    key={`dropdown-list-item-${longName || shortName || name}`}
                    data-testid="Language-Selector-Mobile-Item"
                  >
                    <a
                      href={url}
                      target={isInIFrame ? '_parent' : target}
                      className={classNames(
                        {
                          'underline decoration-2 decoration-yellow underline-offset-8':
                            languageActiveIndex === index,
                        },
                        'whitespace-nowrap hover:text-grey-500'
                      )}
                      data-testid="Language-Selector-Mobile-Link"
                      lang={lang}
                    >
                      {longName || shortName || name}
                    </a>
                  </li>
                )
              )}
            </ul>
          )}
        </div>
      </ShadowContainerVertical>
    </motion.div>
  );
};

export default MobileLanguageSelector;
